import React from 'react';
import Timer from "./Timer";
import Dialog from "./Dialog";
import Avatar from "../../../../core/Avatar/Avatar";
import {SUIT_VALUES} from "../../../../constants/index.jsx";
import {useSelector} from "react-redux";

function Player(props) {
    const {
        playerData,
        position,
        avatarIndex,
        nickName,
        timers,
        isActive,
        children,
        isViewRoom
    } = props;
    const isMobile = useSelector(state => state.user.isMobile);


    return (
        <div className={`player player__${position}`}>
            {playerData?.isTrumpAuthor && !isMobile && <i className="player__trump-author icon-1"/>}
            <div className="player--info">
                <div className="player--info--wrapper">
                    <div className="player--avatar">
                        <Dialog dialog={playerData?.speech}/>
                        <div
                            className={`
                            player--avatar--content
                            ${playerData?.isTrumpAuthor && playerData?.selectedTrump ? `icon-${SUIT_VALUES[playerData?.selectedTrump]}` : ""}`
                            }>
                            <Avatar externalAvatarIndex={avatarIndex}/>
                        </div>
                        {
                            !isViewRoom && <Timer
                                timers={timers}
                                isActive={isActive}
                            />
                        }
                    </div>
                    <p className="player--info--id">{nickName}</p>
                </div>
                {children}
            </div>
        </div>
    )
}

export default Player
